module.exports = __webpack_public_path__ + "img/1_x4.69dffea7.png";